module.exports = __webpack_public_path__ + "static/10-937f5fed21464428560797fb952372e8.jpg";